/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LayerResultsFilter
 */
export interface LayerResultsFilter {
    /**
     * 
     * @type {Array<string>}
     * @memberof LayerResultsFilter
     */
    types?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof LayerResultsFilter
     */
    includeAll: boolean;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsFilter
     */
    currency?: string;
}

/**
 * Check if a given object implements the LayerResultsFilter interface.
 */
export function instanceOfLayerResultsFilter(value: object): value is LayerResultsFilter {
    if (!('includeAll' in value) || value['includeAll'] === undefined) return false;
    return true;
}

export function LayerResultsFilterFromJSON(json: any): LayerResultsFilter {
    return LayerResultsFilterFromJSONTyped(json, false);
}

export function LayerResultsFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): LayerResultsFilter {
    if (json == null) {
        return json;
    }
    return {
        
        'types': json['types'] == null ? undefined : json['types'],
        'includeAll': json['includeAll'],
        'currency': json['currency'] == null ? undefined : json['currency'],
    };
}

export function LayerResultsFilterToJSON(json: any): LayerResultsFilter {
    return LayerResultsFilterToJSONTyped(json, false);
}

export function LayerResultsFilterToJSONTyped(value?: LayerResultsFilter | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'types': value['types'],
        'includeAll': value['includeAll'],
        'currency': value['currency'],
    };
}

